import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import questionsEditorReducers from 'src/modules/QuestionsEditor/reducers';
import emailsReducers from 'emails/reducers/rootReducer';
import rootReducer from './reducers/globalReducer';
import devTestReducers from './modules/DevTest/reducers/rootReducer';
import translationsEditorReducers from './modules/TranslationsEditor/reducers/rootReducer';
import importMappingReducers from './modules/ImportMapping/reducers/rootReducer';
import lookupsReducers from './modules/FileLookups/reducers/rootReducer';
import emailTemplatesReducers from './modules/EmailTemplates/reducers/rootReducer';
import userReducers from './modules/Users/reducers/rootReducer';

// export const store = createStore(
//   combineReducers({
//     global: rootReducer,
//     emails: emailsReducers,
//   }),
//   composeWithDevTools(applyMiddleware(thunk)),
// );

const composeEnhancers = composeWithDevTools({
  trace: true,
  traceLimit: 25,
});

export const store = createStore(
  combineReducers({
    global: rootReducer,
    emails: emailsReducers,
    questionsEditor: questionsEditorReducers,
    devTest: devTestReducers,
    translationsEditor: translationsEditorReducers,
    importMapping: importMappingReducers,
    lookups: lookupsReducers,
    emailTemplates: emailTemplatesReducers,
    users: userReducers,
  }),
  composeEnhancers(applyMiddleware(thunk)),
);

export default store;
